import React, { useCallback, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Swiper, SwiperSlide } from 'swiper/react'
import moment from 'moment'
import CLogLike from "../../../components/like/index";
import CLogComment from "../../../components/comment/index";
import CLogShare from "../../../components/share/index";
import CLogShopLook from "../../../components/shop/index";
import { FormattedMessage } from 'react-intl'
import { IMAGE_GEEKO_LTD } from '../../../../../../constants'
import withClogScroll from '../../../../../hocs/clog-scoll'
import { useQuery } from '../../../../../hooks/common'
import { ProductSwiper } from '../../../video-clogs/components/list'
import { Link, useHistory } from 'react-router-dom'

const ImageSwiper = props => {
    useStyles(classes)
    const { images, aspectRatio, videoLinkEvent } = props
    const [activeIndex, setActiveIndex] = useState(1)

    const slideHandle = useCallback(swiper => {
        setActiveIndex(swiper.activeIndex)
    }, [])


    return <Swiper onSlideChange={slideHandle} spaceBetween={10}>
        {
            images?.map((image, index) => <SwiperSlide key={index}>
                <div style={{ aspectRatio }} className={classes.Image} onClick={videoLinkEvent}>
                    <LazyLoadImage src={image} />
                </div>
            </SwiperSlide>)
        }
        <span className={classes.SwiperCount}>{`${activeIndex}/${images?.length}`}</span>
    </Swiper>
}

export default withClogScroll(props => {
    useStyles(classes)

    const { showing, position, innerRef } = props
    const query = useQuery();
    const history = useHistory();

    const { mainImageWidth, mainImageHeight, images, description, customerName, numberOfLike, liked, numberOfComment, createDate, customerId, tags, mainImage } = showing
    const aspectRatio = mainImageWidth && mainImageHeight ? `${mainImageWidth} / ${mainImageHeight}` : undefined

    const videoLinkEvent = () =>{
        if(showing?.type === 2){
            history.push(`/v-shop/vi/${showing?.id}?tab=${query?.tab}`);
        }
    }

    const handleClick = (tag) =>{
        if(window.GeekoSensors){
			window.GeekoSensors.Track("ClogTagClick", {
				tab:tag?.value
			})
		}
    }

    return <div 
        className={classes.Container} 
        ref={innerRef}
        data-type={'图片'}
        data-id={mainImage}
        data-position={position}
        data-tab={query?.tab || ""}
    >
        <div className={classes.SocialArea}>
            <div className={classes.Customer}>
                <div className={classes.Avatar} style={{background:`url(${!!customerId?`https://s3-us-west-2.amazonaws.com/image.chic-fusion.com/icon/${customerId}`:`${IMAGE_GEEKO_LTD}/chicme/20220801/clog_default_icon.svg`}) center/cover no-repeat;`}}></div>
                <div>
                    <div className={classes.CustomerName}>{customerName}</div>
                    <div className={classes.CustomerPublished}>{
                        createDate ? moment(createDate).calendar({
                            sameDay: '[Today]',
                            nextDay: '[Tomorrow]',
                            nextWeek: 'dddd',
                            lastDay: '[Yesterday]',
                            lastWeek: '[Last] dddd',
                            sameElse: 'DD/MM/YYYY'
                        }) : ''
                    }</div>
                </div>
            </div>

            {/* <span className={classes.FollowedIcon}>Follow</span> */}
        </div>

        <div className={classes.ImageArea}>
            {
                images?.length > 1 ? <ImageSwiper images={images} aspectRatio={aspectRatio} videoLinkEvent={videoLinkEvent} /> : <div style={{ aspectRatio }} className={classes.Image} onClick={videoLinkEvent}>
                    <LazyLoadImage src={images?.[0]} />
                </div>
            }

            {/* {
                showing?.products?.length > 0 && <CLogShopLook 
                    products={showing?.products}
                    sensors={{
                        clogId: mainImage,
                        resource_position: '1'
                    }}
                    render={()=>{
                        return <span className={classes.ShopIcon}>
                            <span></span>
                            <span><FormattedMessage id="shop_the_look" defaultMessage="Shop The Look" /></span>
                        </span>
                    }}
                />
            } */}
            
        </div>

        <div className={classes.Tools}>
            <CLogLike 
                liked={liked} 
                showing={showing} 
                numberOfLike={numberOfLike} 
                className={classes.MarinLeft0}
            />
            
            <CLogComment 
                commentId={showing?.id} 
                commentCount={numberOfComment} 
                className={classes.MarinLeft35}
            />

            <CLogShare 
                fetchParams={{urlCode: "CLI0", params: JSON.stringify({ id: showing?.id })}}
                // sharePrefix={`${config?.name} ${selectedProduct?.name} `}
                shareImageurl={images?.[0]}
                render={() =><span className={`${classes.ToolIcon} ${classes.MarinLeft35}`}>
                    <span className={classes.Icon} icon="&#xe7b1;" />
                </span>}
            />
            
        </div>
        
        {
            showing?.products?.length > 0 && <div className={classes.ShopLook}>
                <p><FormattedMessage id="shop_the_look" defaultMessage="Shop The Look" /></p>

                <ProductSwiper 
                    products={showing?.products} 
                    sensors={{
                        clogId: mainImage,
                        resourcepage_title: 'clog',
                        resource_type: '20',
                        resource_content: 'shop the look',
                        resource_position: '1'
                    }} 
                />
            </div>
        }
        

        <div className={classes.Name}>
            {
                tags?.map((tag, index) =><Link onClick={(e)=>handleClick(tag)} to={`/v-shop/tag?tag=${tag?.value}&tagname=${tag?.name}`} className={classes.HashTag} key={index}>#{tag?.name || tag?.value}{' '}</Link>)
            }
            <span className={classes.Desc}>{description}</span>
        </div>
    </div>
})